import { render } from "./ThemePreview.vue?vue&type=template&id=53eb2162&scoped=true"
import script from "./ThemePreview.vue?vue&type=script&lang=js"
export * from "./ThemePreview.vue?vue&type=script&lang=js"

import "./ThemePreview.vue?vue&type=style&index=0&id=53eb2162&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eb2162"]])

export default __exports__